import React from "react";
import 'semantic-ui-css/semantic.min.css'
import { Route, Switch, BrowserRouter } from "react-router-dom";

import NavBar from "./components/NavBar/navBar";
import LandingDashboard from './components/Landing/landingDashboard';
import Ziplyne_walkme from './components/Ziplyne-vs-walkme/ziplyne_walkme';
import Ziplyne_for_workday from './components/Ziplyne-for-workday/ziplyne-for-workday';
import Ziplyne_pendo from './components/Ziplyne-vs-pendo/ziplyne-vs-pendo';
import Ziplyne_for_salesForce from './components/Ziplyne-for-salesforce/ziplyne-for-salesforce';
import Ziplyne_for_sap from './components/Ziplyne-for-sap/ziplyne-for-sap';
import Ziplyne_whatfix from './components/Ziplyne-vs-whatfix/ziplyne_whatfix';
import Ziplyne_app from './components/Ziplyne-application/ziplyne-app';
import Australia_council from './components/australia-council/australia-dashboard';
import Control_center from './components/Control-center/control-center';
import Footer from "./components/Footer/footer";

const App = () => {
  return (
    <BrowserRouter>
      <NavBar />
      <Switch>
        <Route exact path="/" component={LandingDashboard} />
        <Route exact path="/walkme" component={Ziplyne_walkme} />
        <Route exact path="/workday" component={Ziplyne_for_workday} />
        <Route exact path="/pendo" component={Ziplyne_pendo} />
        <Route exact path="/salesforce" component={Ziplyne_for_salesForce} />
        <Route exact path="/sap" component={Ziplyne_for_sap} />
        <Route exact path="/whatfix" component={Ziplyne_whatfix} />
        <Route exact path="/application" component={Ziplyne_app} />
        <Route exact path="/council" component={Australia_council} />
        <Route exact path="/controlcenter" component={Control_center} />
      </Switch>
      <Footer />
    </BrowserRouter>
  )
}

export default App;
